'use strict';

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import {validate} from 'jsonschema';
import moment from "moment";

import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import CloseButton from 'react-bootstrap/CloseButton';

import {isFalse} from "./Utils";

class BannerModal extends Component {
    constructor(props) {
        super(props);
        this.props = props;

        this.state = {
            open: (this.isBetweenStartEnd() && isFalse(Cookies.get(this.props.id)))
        }
    }

    schema = () => {
        return {
            "type": "object",
            "properties": {
                "id": {"type": "string", "minLength": 4, "maxLength": 64},
                "start": {"type": "string", "format": "date"},
                "end": {"type": "string", "format": "date"},
                "title": {"type": "string", "minLength": 1},
                "message": {"type": ["object", "string"], "minLength": 1},
            },
            "required": ["id","start","end","title","message"]
        }
    }

    onHide = () => {
        Cookies.set(
            this.props.id,
            true,
            {
                expires: this.getExpiresDaysCount(this.props.end),
                sameSite: 'strict',
                secure: true
            }
        );
        this.setState({open: false});
    }

    isBetweenStartEnd = () => {
        const now = moment();
        let start = this.props.start;
        let end = this.props.end;

        if (!moment.isMoment(start)) {
            start = moment(this.props.start);
        }

        if (!moment.isMoment(end)) {
            end = moment(this.props.end);
        }

        return now.isBetween(start, end);
    }

    getExpiresDaysCount = () => {
        const dayMilliseconds = (1000 * 60 * 60 * 24);
        const now = new Date();
        let diffTime = 365 * dayMilliseconds;
        const end = this.props.end;

        if (typeof end === 'object') {
            diffTime = end.getTime() - now.getTime();
        } else if (typeof end === 'string') {
            diffTime = new Date(end).getTime() - now.getTime();
        }

        return (diffTime / dayMilliseconds) + 2;
    }

    render() {
        let component = null;
        if ( validate(this.props, this.schema()).errors.length === 0 ) {
            let modalBody;
            if ( typeof this.props.message === "object") {
                modalBody = this.props.message;
            } else {
                const createMessage = () => {
                    return {__html: this.props.message};
                }

                modalBody = <div dangerouslySetInnerHTML={createMessage()} />
            }

            component =
                <Modal show={this.state.open}
                       onHide={this.onHide}
                       aria-labelledby="banner-modal-title"
                       backdrop="static"
                       centered>
                    <Modal.Header className="bg-purple py-4">
                        <Modal.Title id="banner-modal-title" className="text-white h2">
                            {this.props.title}
                        </Modal.Title>
                        <CloseButton variant="white" onClick={this.onHide} />
                    </Modal.Header>
                    <Modal.Body>
                        {modalBody}
                    </Modal.Body>
                    <Modal.Footer className="text-center">
                        <Button variant="primary" onClick={this.onHide}>
                            OK, I got it
                        </Button>
                    </Modal.Footer>
                </Modal>;
        }

        return component;
    }
}

/*
{
    id: '', // string for cookie id
    start: '', // date message would start showing
    end: '', // date message would stop showing
    title: '', // Modal title text
    message: '', // Modal body content message
}
 */
BannerModal.propTypes = {
    id: PropTypes.string.isRequired,
    start: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date)
    ]).isRequired,
    end: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date)
    ]).isRequired,
    message: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]).isRequired,
    title: PropTypes.string.isRequired
}

export default BannerModal;